'use client'
import React from 'react'
import Head from 'next/head'
import Image from 'next/image'

import ContactSection from '../../../app/_components/Section/Contact'
import Divider from '../../../app/_components/Section/Divider'
import teamMembersData from '../../../app/_utilities/data/sections/teamMembers.json'
import PageBanner from '../PageBanner'

const Team: React.FC = () => {
  return (
    <>
      <Head>
        <title>Team - Pyther Innovation</title>
        {/* <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SERVER_URL}/team`} /> */}
      </Head>
      <PageBanner pageName={'Team'} pageTitle={'Leadership Team'} />
      {/* team section */}
      <section className="mil-team mil-p-40-10">
        <div className="container">
          {/* <CareerImageSlider /> */}

          <h3 className="mil-text-center mil-mb-40 mil-h3 mil-font">
            <p style={{marginBottom: '0'}}>The bigger the <span className="mil-accent">Dream,</span></p><p style={{marginBottom: '0'}}>the more important the <span className="mil-accent">Team.</span></p>
{/* <span className="mil-accent">
              reader will be <br />
              distracted
            </span>{' '} */}
          </h3>
          <div className="row team-img" style={{display:'flex', justifyContent: 'space-around'}}>
            {teamMembersData.map((member, index) => (
              <div key={index} className="col-sm-6 col-lg-4 col-6" style={{
                display:'flex',
                alignItems:'center',
                textAlign:'center',
                justifyContent: 'center'
              }}>
                <div className="mil-team-card mil-mb-60 service-img">
                  <div className="mil-image-frame mil-mb-30 mil-font-2">
                    <Image
                      src={member.image}
                      height={700}
                      width={700}
                      alt={`Team member ${member.name}`}
                    />
                    <div className="mil-team-circle" />
                  </div>
                  <h4 className="mil-mb-10 mil-h4">{member.name}</h4>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <p className='mil-font-2' style={{ marginRight: '10px' }}>{member.position}</p>
                    <a
                      target="_blank"
                      href={member.linkedin}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      aria-label={`${member.name}'s LinkedIn Profile`}
                    >
                      <i className="fab fa-linkedin" style={{ fontSize: '24px', color: '#0077b5' }}></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* <Perks /> */}

      {/* Divider section */}
      <Divider />

      {/* contact section */}
      <ContactSection />
    </>
  )
}
export default Team
